import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaxService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllTax(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Tax,
      queryString:`Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async updateTax(id,taxRate){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Tax,
    },{
      id:id,
      taxRate:taxRate
    });
    return await firstValueFrom(observable);
  }

  async createTax(taxRate){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Tax,
    },{
      taxRate:taxRate
    });
    return await firstValueFrom(observable);
  }
  
  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
